module.exports = __webpack_public_path__ + "img/icon-alert-hight-full.3b0f559f.svg";